import '../styles/Header.css'
import {useState, useEffect} from 'react'
import {Link, useLocation} from 'react-router-dom';
import {usePerson} from '../hooks/hooks_index';
import { useAuthUser, MediaIcon } from "../components/components_index";

export default function Header() {
  const [isVisible, setIsVisible] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY <= 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className='header-root'>
      <div className={`site-header ${isVisible ? 'visible' : 'hidden'}`}>
        <Title toggleMenu={() => setMenuOpen(!menuOpen)} menuOpen={menuOpen}/>
        <NavBar menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
      </div>
    </div>
  );
}

function Title({toggleMenu, menuOpen}) {
  return (
    <div className='site-title'>
      <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        {menuOpen ? '\u2715' : '☰'}
      </button>
      <div className='site-title-words'>Spradley Family</div>
      <LogoButton toggleMenu={toggleMenu} menuOpen={menuOpen}/>
    </div>  
  );
}

function LogoButton({toggleMenu, menuOpen}) {
  const { loginID } = useAuthUser();
  // const personData = usePerson(loginID);
  const {data: personData, isLoading: personLoading, error: personError} = usePerson(loginID);

  if (personLoading || personError || !personData) return "";

  const siteImg = personData.profile_pic ?? "S_logo_PNG.png";
  // const siteImg = "S_logo_PNG.png";
  return (
    <Link to={'/profile'} className='site-logo-button' title="Visit Profile" onClick={() => {if (menuOpen) {toggleMenu()}}}>
      <MediaIcon mediaID={siteImg} className="site-logo" alt="logo" />
    </Link>
  )
}

function NavBar({menuOpen, setMenuOpen}) {
  const tabs=['Home', 'Calendar', 'Directory', 'Reunions', 'Map', 'Gallery', 'Family Tree'];
  return (
    <div className={`nav-bar ${menuOpen ? 'open' : ''}`}>
      {tabs.map((tab, index) => (
        <Tab key={index} tab={tab} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      ))}
    </div>
  );
}

function Tab({tab, menuOpen, setMenuOpen}) {
  const safeClass = tab.toLowerCase().replace(/\s+/g, '-')
  const pageLink = (tab === 'Home') ? '/' : ('/'+ safeClass);

  const location = useLocation();
  const isActive = location.pathname === pageLink;

  const isCurPage = 'tab ' + safeClass + (isActive ? " active" : " inactive");

  return (
    <Link
      to={pageLink}
      className={isCurPage}
      onClick={() => setMenuOpen(!menuOpen)}
    >
      <div className='tab-word'>{tab}</div>
    </Link>
  )
}
